<template>
  <div class="wbkonfigurator">
    <wizard
      @wizardFinished="startLoading"
      :translationHelper="translationHelper"
      @wizard-open-change="wizardOpenChange"
      :isWizardOpen="isWizardOpen"
    />
    <div
      class="search-all-btn"
      v-if="!showBookmarks && !isWizardOpen && coursesLoaded"
    >
      <a class="link-btn" href="#" @click.prevent="loadAll()"
        >{{ translationHelper.getTranslation("wbk_Filter_All_Courses") }}
      </a>
    </div>
    <bookmark-link
      :showBookmarks="showBookmarks"
      :isWizardOpen="isWizardOpen"
      :bookMarkTotal="bookMarkTotal"
      :translationHelper="translationHelper"
      @click="toggleBookmarks"
    />
    <debug-mode-filters
      :showToggler="!showBookmarks && isDebugMode"
      :showFilters="showFilter && !showBookmarks"
      @toggle-show-filter="toggleFilter"
      @filter-executed="filterExecuted"
      :translationHelper="translationHelper"
      :originalCourses="originalCourses"
      :originalParents="originalParents"
    />
    <div class="bookmark-btn-hide" v-if="showBookmarks">
      <a class="link-btn" href="#" @click.prevent="toggleBookmarks">{{
        translationHelper.getTranslation("wbk_Btn_BackToResults")
      }}</a>
    </div>
    <p></p>
    <div class="loading" v-if="isLoading">
      <img
        src="/Assets/Campus/Common/img/Icons/loading-blue-50x50.gif"
        :alt="translationHelper.getTranslation('wbk_Loading')"
        style="margin: 30px"
      />
    </div>
    <no-results
      v-if="courses.length == 0 && coursesLoaded && !showBookmarks"
      @restart-wizard="restartWizard"
      :no-result-data="supportInfo"
      :translationHelper="translationHelper"
    ></no-results>
    <div v-else>
      <div class="parent-courses" v-if="!isLoading && !showBookmarks">
        <h3
          v-if="
            parentsTitle && (parents.length > 0 || parentsShowNoResultMessage)
          "
        >
          {{ parentsTitle }} ({{ totalParents }})
        </h3>
        <p
          v-if="
            !showBookmarks && (parents.length > 0 || parentsShowNoResultMessage)
          "
        >
          <span class="infoText">{{ infoText }}</span>
        </p>

        <div class="wb-grid-container" v-if="parents.length > 0">
          <div v-for="parent in parents" :key="parent.id" class="wb-grid-item">
            <course-item
              :translationHelper="translationHelper"
              :course="parent"
              @click="selectCourse"
              @bookmark="courseBookmarkChanged"
            />
          </div>
        </div>
        <div
          v-if="showLoadMoreParents"
          style="text-align: center; margin-top: 50px"
        >
          <button @click="getNextParentsPage">
            {{ translationHelper.getTranslation("wbk_Btn_ShowMoreResults") }}
          </button>
        </div>
        <div v-if="parents.length === 0 && parentsShowNoResultMessage">
          {{ translationHelper.getTranslation("wbk_ParentsNoResultMessage") }}
        </div>
      </div>
      <div class="courses" v-if="!isLoading && courses.length > 0">
        <p></p>
        <h3 v-if="showBookmarks">
          {{ translationHelper.getTranslation("wbk_BookmarksTitle") }}
        </h3>
        <h3 v-if="!isAllCourses && !showBookmarks">
          {{ coursesTitle }} ({{ totalCourses }})
        </h3>
        <p v-if="!isAllCourses && !showBookmarks">
          <span class="infoText">{{ infoText }}</span>
        </p>
        <h3 v-if="isAllCourses && !showBookmarks">
          {{ translationHelper.getTranslation("wbk_DisplayCounter") }} ({{
            totalCourses
          }})
        </h3>
        <div class="wb-grid-container">
          <div v-for="course in courses" :key="course.id" class="wb-grid-item">
            <course-item
              :translationHelper="translationHelper"
              :course="course"
              @click="selectCourse"
              @bookmark="courseBookmarkChanged"
            />
          </div>
        </div>
        <div v-if="showLoadMore" style="text-align: center; margin-top: 50px">
          <button @click="getNextPage">
            {{ translationHelper.getTranslation("wbk_Btn_ShowMoreResults") }}
          </button>
        </div>
      </div>
      <support-teaser
        v-if="(courses.length > 0 && coursesLoaded) || showBookmarks"
        :result-teaser-data="supportInfo"
        :translationHelper="translationHelper"
      ></support-teaser>
    </div>
    <modal-course-relations
      @close-window="
        selectedCourse = null;
        showModal = false;
      "
      @bookmark="courseBookmarkChanged"
      @selectCourse="selectCourse"
      :selectedCourse="selectedCourse"
      :showModal="showModal"
      :translationHelper="translationHelper"
    />
  </div>
</template>
<script>
import CourseItem from "./components/CourseItem.vue";
import Wizard from "./components/Wizard.vue";
import WBKonfigurator from "../../../_Api/WBKonfigurator";
import { TranslationHelper } from "../../../_Base/Utils";
import DebugModeFilters from "./components/DebugModeFilters.vue";
import ModalCourseRelations from "./components/ModalCourseRelations.vue";
import NoResults from "./components/NoResults.vue";
import SupportTeaser from "./components/SupportTeaser.vue";
import BookmarkLink from "./components/BookmarkLink.vue";

export default {
  components: {
    CourseItem,
    Wizard,
    DebugModeFilters,
    ModalCourseRelations,
    NoResults,
    SupportTeaser,
    BookmarkLink
  },
  data() {
    return {
      maxCoursePerPage: 12,
      currentPageIndex: 1,
      maxParentsPerPage: 12,
      currentParentsPageIndex: 1,
      translationHelper: {},
      showModal: false,
      selectedCourse: null,
      coursesLoaded: false,
      isLoading: false,
      isDebugMode: false,
      originalCourses: [],
      courses: [],
      parentsShowNoResultMessage: false,
      coursesTitle: "",
      parentsTitle: "",
      originalParents: [],
      parents: [],
      bookmarkedCourses: [],
      showBookmarks: false,
      supportInfo: {},
      showFilter: false,
      query: {},
      isWizardOpen: true,
    };
  },

  created() {
    let glassItemData = this.$parent.$data.glassItemData;
    this.isDebugMode = glassItemData.isDebugMode;
    this.supportInfo = glassItemData.supportInfo;
    this.translationHelper = new TranslationHelper(
      this.$parent.$data.initialTranslations
    );
  },
  mounted() {
    if (window.location.search) {
      const url = new URL(window.location);
      const queryParams = {
        hasExistingWbk: url.searchParams.get("hasExistingWbk") === "true",
        themaQuery: url.searchParams.get("themaQuery"),
        completedCourseId: url.searchParams.get("completedCourseId"),
        completedCourseTitle: url.searchParams.get("completedCourseTitle"),
        wbkType: url.searchParams.get("wbkType"),
        loadAllCourses: url.searchParams.get("loadAllCourses") == "true",
      };
      this.startLoading(queryParams);
    } else if (this.isDebugMode) {
      this.startLoading({ loadAllCourses: true });
    }
  },
  computed: {
    isAllCourses() {
      return this.query.loadAllCourses;
    },
    infoText() {
      if (this.query.hasExistingWbk) {
        return this.query.completedCourseTitle;
      } else {
        return this.query.themaQuery;
      }
    },
    totalCourses() {
      return this.originalCourses.length; //this.courses.length;
    },
    bookMarksExist() {
      return this.bookmarkedCourses.length > 0;
    },
    bookMarkTotal() {
      return this.bookmarkedCourses.length;
    },
    showLoadMore() {
      return (
        this.originalCourses.length >
          this.maxCoursePerPage * this.currentPageIndex && !this.showBookmarks
      );
    },
    totalParents() {
      return this.originalParents.length; //this.parents.length;
    },
    showLoadMoreParents() {
      return (
        this.originalParents.length >
          this.maxParentsPerPage * this.currentParentsPageIndex &&
        !this.showBookmarks
      );
    },
  },
  watch: {
    showModal(newValue) {
      var body = document.body;
      if (newValue) {
        body.classList.add("noscroll");
      } else {
        body.classList.remove("noscroll");
      }
    },
  },
  methods: {
    toggleFilter(newValue) {
      this.showFilter = newValue;
    },
    loadAll() {
      this.startLoading({ loadAllCourses: true });
    },
    startLoading(query) {
      console.log("wizard finished", query);
      this.query = query;
      this.originalCourses = [];
      1;
      this.courses = [];
      this.originalParents = [];
      this.parents = [];
      this.coursesLoaded = false;
      this.load();
    },
    toggleBookmarks() {
      this.showBookmarks = !this.showBookmarks;
      if (this.showBookmarks) {
        this.courses = this.bookmarkedCourses;
      } else {
        this.courses = this.originalCourses.slice(
          0,
          this.currentPageIndex * this.maxCoursePerPage
        );
        this.parents = this.originalParents.slice(
          0,
          this.currentParentsPageIndex * this.maxParentsPerPage
        );
        this.$emit("reset-filter");
      }
    },
    getNextPage() {
      this.currentPageIndex++;
      this.courses = this.originalCourses.slice(
        0,
        this.currentPageIndex * this.maxCoursePerPage
      );
    },
    getNextParentsPage() {
      this.currentParentsPageIndex++;
      this.parents = this.originalParents.slice(
        0,
        this.currentParentsPageIndex * this.maxParentsPerPage
      );
    },
    courseBookmarkChanged(course) {
      course.isBookmarked = !course.isBookmarked;

      // add to bookmarks if it doesn't already exist
      const bId = this.bookmarkedCourses.findIndex((c) => c.id === course.id);
      if (course.isBookmarked) {
        if (bId === -1) {
          this.bookmarkedCourses.push(course);
          if (this.showBookmarks) {
            // we are currently showing bookmarks, so add our bookmark to the current items
            this.courses.push(course);
            // todo: add to last row or create new row if should fit here!
          }
        }
      } else {
        // remove from bookmarks if exists
        if (bId !== -1) {
          this.bookmarkedCourses.splice(bId, 1);
        }
      }
      localStorage.setItem("bookmarks", JSON.stringify(this.bookmarkedCourses));
    },

    filterExecuted(filteredCourses, filteredParents) {
      this.courses = filteredCourses;
      this.parents = filteredParents;
      return false;
    },
    load() {
      this.isLoading = true;
      this.currentPageIndex = 1;
      if (this.query.loadAllCourses) {
        WBKonfigurator.searchDummy()
          .then((result) => {
            this.handleLoadResults(result.data);
          })
          .catch((error) => {
            console.error(error);
            this.courses = [];
            this.isLoading = false;
          })
          .finally(() => {
            this.coursesLoaded = true;
          });
      } else {
        if (this.query.hasExistingWbk) {
          WBKonfigurator.searchByCompletedCourses(this.query.completedCourseId)
            .then((result) => {
              console.log("searchByCompletedCourses", result);
              this.handleLoadResults(result.data);
            })
            .catch((error) => {
              console.error(error);
              this.courses = [];
              this.isLoading = false;
            })
            .finally(() => {
              this.coursesLoaded = true;
            });
        } else {
          const types = [];
          if (this.query.wbkType && this.query.wbkType != "ALL") {
            var splitTypes = this.query.wbkType.split("-");
            splitTypes.forEach((wbkType) => {
              types.push(wbkType);
            });
          }
          WBKonfigurator.searchByTopic(this.query.themaQuery, types)
            .then((result) => {
              console.log("searchbytopic", result);
              this.handleLoadResults(result.data);
            })
            .catch((error) => {
              console.error(error);
              this.courses = [];
              this.isLoading = false;
            })
            .finally(() => {
              this.coursesLoaded = true;
            });
        }
      }
    },
    handleLoadResults(resultData) {
      this.parentsTitle = resultData.parentsTitle;
      this.coursesTitle = resultData.coursesTitle;
      this.parentsShowNoResultMessage = resultData.parentsShowNoResultMessage;
      var courses = resultData.courses;
      var parents = resultData.parents;
      this.loadBookmarks();
      for (let i = 0; i < courses.length; i++) {
        courses[i].isBookmarked = this.isInBookmarks(courses[i]);
        courses[i].details = {};
      }
      this.courses = courses.slice(
        0,
        this.currentPageIndex * this.maxCoursePerPage
      );
      this.originalCourses = courses;
      this.handleParentsLoadResults(parents);
      this.isLoading = false;
    },
    handleParentsLoadResults(parents) {
      for (let i = 0; i < parents.length; i++) {
        parents[i].isBookmarked = this.isInBookmarks(parents[i]);
        parents[i].details = {};
      }
      this.parents = parents.slice(
        0,
        this.currentParentsPageIndex * this.maxParentsPerPage
      );
      this.originalParents = parents;
    },
    selectCourse(course) {
      this.selectedCourse = course;
      WBKonfigurator.getDetail(course.id)
        .then((result) => {
          console.log("get details", result);
          this.$nextTick(() => {
            this.setCourseBookmarks(result.data.compulsoryModules);
            this.setCourseBookmarks(result.data.electiveCompulsoryModules);
            this.setCourseBookmarks(result.data.electiveModules);
            this.setCourseBookmarks(result.data.parents);
            this.setCourseBookmarks(result.data.similars);
            course.details = result.data;
            this.showModal = true;
            console.log("course", course);
          });
        })
        .catch((error) => {
          console.error(error);
        });
    },
    setCourseBookmarks(courses) {
      for (let i = 0; i < courses.length; i++) {
        courses[i].isBookmarked = this.isInBookmarks(courses[i]);
        courses[i].details = {};
      }
    },
    loadBookmarks() {
      var bookmarksSerialized = localStorage.getItem("bookmarks");
      if (bookmarksSerialized) {
        this.bookmarkedCourses = JSON.parse(bookmarksSerialized);
      }
    },
    isInBookmarks(course) {
      if (this.bookmarkedCourses.find((c) => c.id === course.id)) {
        return true;
      }
      return false;
    },
    wizardOpenChange(newValue) {
      if (newValue) {
        this.showBookmarks = false;
        this.parentsTitle = "";
        this.originalCourses = [];
        this.courses = [];
        this.originalParents = [];
        this.parents = [];
        this.parentsShowNoResultMessage = false;
        this.coursesLoaded = false;
        //   this.parentsShowNoResultMessage = true
        //   this.coursesLoaded= true
      }
      this.isWizardOpen = newValue;
    },
    restartWizard() {
      this.wizardOpenChange(true);
    },
  },
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
